import React from "react";
import addIcon from "../../../../../assets/images/DeathModuleNew/addIcon.png";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import linkIcon from "../../../../../assets/SVGs/linkIcon.svg";
import linkIconDark from "../../../../../assets/SVGs/linkIconDark.svg";
import addNewIcon from "../../../../../assets/SVGs/add.svg";
import { setActiveStep } from "../../../../../redux/slices/loginSlice";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import "../../../disability/DisabilityDashboard/styles/disbilityDashboardStyle.css";
import { ToolTipCreator } from "../../../../../helpers/ToolTipCreator";

export const DivorceDocumnetCard = ({
  step,
  fileUpload,
  loading,
  documents,
  moduleData,
  width,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const detailList = [
    {
      name: "Module 1",
    },
    { name: "Module 2" },
  ];

  return (
    <div
      className="DisabilityCardMain"
      style={{
        position: "relative",
        width: width ? width : "",
        height: " 100%",
      }}
    >
      <div className="cardHeadingDisability">
        <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
          {moduleData.Icon && (
            <img
              width={66}
              height={56}
              src={moduleData.Icon}
              alt={moduleData.name}
            ></img>
          )}
          <div style={{ display: "flex", alignItems: "baseline", columnGap: "3px" }}>
            {moduleData.name}
            {moduleData &&
              moduleData.tooltip &&
              ["Legal Documentations"].includes(moduleData.name) && (
                <ToolTipCreator name={moduleData.tooltip} />
            )}
          </div>
        </div>
        <div className="uploadButtonsDisability">
          {" "}
          <div
            className="upload"
            style={{ width: "20px", height: "20px" }}
            onClick={() => {
              dispatch(setActiveStep(step));
              history.push("/protector/divorce");
            }}
          >
            <img
              src={addIcon}
              width={12}
              height={12}
              style={{ width: "12px", height: "12px" }}
              alt="addicon"
            ></img>
          </div>
        </div>
      </div>
      {moduleData.Purpose && (
        <div className="cardDisabilityDesc">{moduleData.Purpose}</div>
      )}
      <div
        style={{ maxHeight: "100%", overflowY: "auto", paddingInline: "8px" }}
      >
        {detailList &&
          detailList.length > 0 &&
          detailList.map((item, index) => (
            <div key={index} className="divorce-document-card-inner">
              <span className="divorce-document-heading"> {item.name}</span>
              <div className="divorce-document-card">
                <div className="divorce-card-inner">
                  <img
                    src={
                      documents && documents.length > 0
                        ? linkIconDark
                        : linkIcon
                    }
                    height={24}
                    width={24}
                    alt="fileImage"
                  ></img>
                </div>
                {documents && documents.length > 0 && (
                  <span style={{ color: "#2C419D", fontWeight: "bold" }}>
                    {documents && documents.length}
                  </span>
                )}
              </div>
            </div>
          ))}
      </div>
      <NewLoader isLoading={loading} />
    </div>
  );
};
